import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: "Before Epicdrop, we were blind to lateral movement within our network. Their Sentinel Mesh identified and isolated a dormant threat within 48 hours of deployment. They don't just sell software; they provide absolute perimeter control.",
  author: 'Leontios Makris',
  role: 'CISO',
  company: 'Heliodyne Systems'
}, {
  quote: "The compliance landscape in the EU is unforgiving. Epicdrop's Cipher Veil not only secured our proprietary engineering data but automated our entire GDPR audit trail. It's the most robust security investment we've made.",
  author: 'Zephyra Hadjioannou',
  role: 'VP Engineering',
  company: 'Koronis Maritime'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-brand-darker border-t border-brand-border relative overflow-hidden" data-id="element-226">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_0%_0%,rgba(74,144,217,0.05)_0%,transparent_50%)] pointer-events-none" data-id="element-227" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-228">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-229">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative p-8 md:p-10 bg-brand-dark border border-brand-border rounded-2xl" data-id="element-230">
              <Quote className="absolute top-6 right-8 w-12 h-12 text-brand-steel/10" data-id="element-231" />

              <p className="text-lg text-slate-300 leading-relaxed mb-8 relative z-10" data-id="element-232">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-233">
                <div className="w-12 h-12 rounded-full bg-brand-darker border border-brand-steel/30 flex items-center justify-center" data-id="element-234">
                  <span className="font-mono font-bold text-brand-steel" data-id="element-235">
                    {testimonial.author.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div data-id="element-236">
                  <div className="font-mono font-bold text-white" data-id="element-237">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-brand-cyan" data-id="element-238">
                    {testimonial.role},{' '}
                    <span className="text-slate-400" data-id="element-239">
                      {testimonial.company}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}